<template>
  <span>
    <audio style="display: none;" controls ref="audio" v-on:ended="stop"><source :src="src" ref="source" type="audio/mpeg"></audio>
    <v-btn :disabled="disabled" icon v-on:click="toggle">
      <v-icon :color="color">{{ icon }}</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  props: [
    'src'
  ],
  data () {
    return {
      active: false,
      disabled: false
    }
  },
  computed: {
    icon () {
      return this.active ? 'pause_circle_outline' : 'play_circle_outline'
    },
    color () {
      return this.active ? 'green' : 'dark'
    }
  },
  methods: {
    async stop () {
      this.active = false
      this.$refs.audio.pause()
      this.$refs.audio.load()
    },
    async play () {
      if (this.disabled) {
        return
      }
      this.active = true
      this.$refs.audio.play()
    },
    toggle () {
      if (this.active) {
        this.stop()
      } else {
        this.play()
      }
    }
  }
}
</script>
